/* =====================================================================
   LIVFRESH Sale Buy Box — "Secure Checkout" (Version C), vanilla JS.
   Upload to Shopify Files, load via:
     {{ 'ai-buybox-sale-secure.js' | file_url | script_tag }}
   Reads window.AI_SALE_BUYBOX_CONFIG (built by the section Liquid).

   Cart wiring matches the live LIVFRESH PDP:
     POST /cart/add.js  { id: variantId, selling_plan?: id }
     then window.openCart() (falls back to /cart).
   ===================================================================== */

(function () {
  'use strict';

  var ROOT_SELECTOR = '.ai-sale-buybox';
  var BULLET = '•';
  var MIDDOT = '·';
  var SVGNS = 'http://www.w3.org/2000/svg';

  /* ---------------- helpers ---------------- */

  function money(n) { return '$' + Number(n).toFixed(2); }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (!Object.prototype.hasOwnProperty.call(attrs, k)) continue;
        var v = attrs[k];
        if (v == null || v === false) continue;
        if (k === 'class') node.className = v;
        else if (k === 'html') node.innerHTML = v;
        else if (k === 'text') node.textContent = v;
        else if (k === 'dataset') { for (var dk in v) { if (v[dk] != null) node.dataset[dk] = v[dk]; } }
        else if (k.indexOf('on') === 0 && typeof v === 'function') node.addEventListener(k.slice(2), v);
        else if (v === true) node.setAttribute(k, '');
        else node.setAttribute(k, v);
      }
    }
    if (children) {
      (Array.isArray(children) ? children : [children]).forEach(function (c) {
        if (c == null || c === false) return;
        node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
      });
    }
    return node;
  }

  // Build an inline SVG icon from a path-spec. `paths` is an array of
  // attribute objects ({ d } or { rect/circle attrs via tag }).
  function icon(spec, opts) {
    opts = opts || {};
    var svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', opts.sw || '1.9');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    spec.forEach(function (s) {
      var t = s.tag || 'path';
      var n = document.createElementNS(SVGNS, t);
      for (var a in s) { if (a !== 'tag') n.setAttribute(a, s[a]); }
      svg.appendChild(n);
    });
    return svg;
  }

  var ICONS = {
    check:  [{ d: 'M5 12.5l4.5 4.5L19 7' }],
    lock:   [{ tag: 'rect', x: 5, y: 11, width: 14, height: 9, rx: 2 }, { d: 'M8 11V8a4 4 0 0 1 8 0v3' }],
    shield: [{ d: 'M12 3l7 3v5c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6z' }, { d: 'M9 12l2 2 4-4' }],
    truck:  [{ d: 'M3 7h11v9H3z' }, { d: 'M14 10h4l3 3v3h-7' },
             { tag: 'circle', cx: 7.5, cy: 17.5, r: 1.8 }, { tag: 'circle', cx: 17.5, cy: 17.5, r: 1.8 }]
  };

  // Payment badges — real brand marks (inline SVG / styled wordmarks).
  var PF = "'Poppins',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif";
  var APPLE_SVG = '<svg width="13" height="13" viewBox="0 0 24 24" fill="#000" aria-hidden="true"><path d="M17.05 12.04c-.03-2.6 2.13-3.85 2.23-3.91-1.22-1.78-3.11-2.02-3.78-2.05-1.61-.16-3.14.95-3.96.95-.81 0-2.07-.93-3.4-.9-1.75.03-3.36 1.02-4.26 2.58-1.82 3.16-.47 7.83 1.31 10.39.87 1.25 1.9 2.66 3.26 2.61 1.31-.05 1.8-.85 3.39-.85 1.58 0 2.03.85 3.41.82 1.41-.02 2.3-1.28 3.16-2.54.99-1.45 1.4-2.86 1.42-2.93-.03-.01-2.73-1.05-2.76-4.16zM14.79 5.06c.72-.87 1.2-2.08 1.07-3.28-1.03.04-2.28.69-3.02 1.56-.66.77-1.24 2-1.08 3.18 1.15.09 2.32-.59 3.03-1.46z"/></svg>';
  var GOOGLE_G = '<svg width="15" height="15" viewBox="0 0 48 48" aria-hidden="true"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>';
  var MC_SVG = '<svg width="26" height="17" viewBox="0 0 36 24" aria-hidden="true"><circle cx="14" cy="12" r="9" fill="#EB001B"/><circle cx="22" cy="12" r="9" fill="#F79E1B"/><path d="M18 5.2a9 9 0 0 1 0 13.6 9 9 0 0 1 0-13.6z" fill="#FF5F00"/></svg>';
  var PAYMENTS = [
    { bg: '#1F72CF', html: '<span style="color:#fff;font:800 6.5px/1.05 ' + PF + ';letter-spacing:.2px;text-align:center;display:inline-block">AMERICAN<br>EXPRESS</span>' },
    { bg: '#fff', border: true, w: 56, html: APPLE_SVG + '<b style="font:800 13px ' + PF + ';color:#000;margin-left:3px">Pay</b>' },
    { bg: '#fff', border: true, w: 64, html: '<span style="font:800 8px ' + PF + ';color:#201E1F;position:relative;padding-bottom:4px;display:inline-block">DISCOVER<span style="position:absolute;left:20%;right:-3%;bottom:0;height:3px;background:#F58220;border-radius:2px"></span></span>' },
    { bg: '#fff', border: true, w: 56, html: GOOGLE_G + '<b style="font:500 12px ' + PF + ';color:#5F6368;margin-left:3px">Pay</b>' },
    { bg: '#fff', border: true, w: 52, html: MC_SVG },
    { bg: '#fff', border: true, w: 58, html: '<span style="font:800 italic 12px ' + PF + '"><span style="color:#003087">Pay</span><span style="color:#009CDE">Pal</span></span>' },
    { bg: '#5A31F4', html: '<b style="color:#fff;font:800 13px ' + PF + '">shop</b>' },
    { bg: '#fff', border: true, html: '<b style="color:#1A1F71;font:800 italic 13px ' + PF + ';letter-spacing:.4px">VISA</b>' }
  ];
  var TRUST = [
    { icon: 'shield', label: '90-Day Money-Back Guarantee' },
    { icon: 'truck',  label: 'Fast Shipping + Easy Returns' },
    { icon: 'lock',   label: 'Safe & Secure Checkout' }
  ];

  /* ---------------- cart wiring ---------------- */

  function addToCart(variantId, sellingPlanId) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var item = { id: variantId, quantity: 1 };
    if (sellingPlanId) item.selling_plan = sellingPlanId;
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (res) {
      if (!res.ok) return res.text().then(function (t) { throw new Error('cart/add.js ' + res.status + ': ' + t); });
      return res.json();
    });
  }

  function openCartDrawer() {
    if (typeof window.openCart === 'function') {
      try { window.openCart(); return true; } catch (e) {}
    }
    var dialog = document.getElementById('miniCart');
    if (dialog && typeof dialog.showModal === 'function') {
      try { dialog.showModal(); return true; } catch (e) {}
    }
    window.location.href = '/cart';
    return false;
  }

  /* ---------------- tubes ---------------- */

  function tubes(cfg, count) {
    if (count >= 5) {
      return el('span', { class: 'tubes pyr' }, [
        el('img', { class: 'ouL', src: cfg.tubeImageUrl, alt: '' }),
        el('img', { class: 'ouR', src: cfg.tubeImageUrl, alt: '' }),
        el('img', { class: 'inL', src: cfg.tubeImageUrl, alt: '' }),
        el('img', { class: 'inR', src: cfg.tubeImageUrl, alt: '' }),
        el('img', { class: 'apex', src: cfg.tubeImageUrl, alt: '' })
      ]);
    }
    if (count === 3) {
      return el('span', { class: 'tubes pyr3' }, [
        el('img', { class: 'bL', src: cfg.tubeImageUrl, alt: '' }),
        el('img', { class: 'bR', src: cfg.tubeImageUrl, alt: '' }),
        el('img', { class: 'apex', src: cfg.tubeImageUrl, alt: '' })
      ]);
    }
    return el('span', { class: 'tubes one' }, el('img', { src: cfg.tubeImageUrl, alt: '' }));
  }

  function titleNode(lines) {
    return (lines || []).map(function (ln) {
      var kids = [ln.t || ''];
      if (ln.em) kids.push(el('em', null, ln.em));
      return el('span', null, kids);
    });
  }

  /* ---------------- card ---------------- */

  function buildCard(inst, card) {
    var cls = 'col' + (inst.state.selectedId === card.id ? ' selected' : '');
    var line = inst.state.subscribed ? card.subscribe : card.onetime;
    var title = (inst.state.subscribed ? card.title : (card.titleOnetime || card.title));
    var saveAmt = line.was ? Math.round(line.was - line.price) : 0;

    var col = el('button', { class: cls, type: 'button', 'aria-pressed': inst.state.selectedId === card.id,
      onclick: function () { setSelected(inst, card.id); } }, [
      el('span', { class: 'card' }, [
        el('span', { class: 'tag ' + (card.tagKind || 'empty') }, card.tag || ''),
        el('span', { class: 'title' }, titleNode(title)),
        el('span', { class: 'shot' }, tubes(inst.cfg, card.tubes))
      ]),
      // red save chip — shows whenever there's a compare-at saving (both modes);
      // when there's no saving (e.g. 1-pack one-time) keep an invisible placeholder
      // so the price below stays aligned with the other cards.
      saveAmt > 0
        ? el('span', { class: 'save' }, 'Save $' + saveAmt)
        : el('span', { class: 'save is-empty', 'aria-hidden': 'true' }, ' '),
      el('span', { class: 'price' }, [
        el('span', { class: 'now' }, money(line.price)),
        line.was ? el('span', { class: 'was' }, money(line.was)) : null
      ])
    ]);
    return col;
  }

  /* ---------------- subscribe & save box ---------------- */

  function giftLi(g) {
    var span = el('span', null, [g.label]);
    if (g.value) span.appendChild(el('em', null, ' ($' + Number(g.value).toFixed(2) + ' value)'));
    return el('li', null, [icon(ICONS.check, { sw: '2.4' }), span]);
  }

  function buildSubBox(inst) {
    var card = currentCard(inst);
    // pill reflects the CURRENT mode's saving (matches the red chip above)
    var line = inst.state.subscribed ? card.subscribe : card.onetime;
    var pillSave = line.was ? Math.round(line.was - line.price) : 0;

    var body = [
      el('span', { class: 'sub-head' }, [
        el('span', { class: 'sub-title' }, 'Subscribe & Save'),
        pillSave > 0 ? el('span', { class: 'sub-pill' }, '+ Save $' + pillSave) : null
      ])
    ];

    if (inst.state.subscribed) {
      var lis = (card.gifts || []).map(giftLi);
      lis.push(el('li', null, [icon(ICONS.check, { sw: '2.4' }), el('span', null, 'Refilled every ' + card.freq)]));
      body.push(el('ul', { class: 'sub-benefits' }, lis));
    } else {
      // One-time: free products that still apply are listed as active...
      var og = card.giftsOnetime || [];
      if (og.length) body.push(el('ul', { class: 'sub-benefits' }, og.map(giftLi)));
      // ...and the lost subscriber perks are shown blurred under a lock overlay.
      var ogLabels = og.map(function (g) { return g.label; });
      var lost = (card.gifts || []).filter(function (g) { return ogLabels.indexOf(g.label) === -1; });
      var lostLis = lost.map(giftLi);
      lostLis.push(el('li', null, [icon(ICONS.check, { sw: '2.4' }), el('span', null, 'Refilled every ' + card.freq)]));
      body.push(el('div', { class: 'sub-locked-wrap' }, [
        el('ul', { class: 'sub-benefits blurred', 'aria-hidden': 'true' }, lostLis),
        el('div', { class: 'sub-lock-overlay' }, [icon(ICONS.lock, { sw: '2.2' }), 'Subscriber benefits locked'])
      ]));
    }

    return el('button', { type: 'button', class: 'sub-box' + (inst.state.subscribed ? ' on' : ''),
      'aria-pressed': inst.state.subscribed,
      onclick: function () { setSubscribed(inst, !inst.state.subscribed); } }, [
      el('span', { class: 'sub-check', 'aria-hidden': 'true' }, icon(ICONS.check, { sw: '3' })),
      el('span', { class: 'sub-body' }, body)
    ]);
  }

  /* ---------------- secure checkout ---------------- */

  function buildSecure() {
    var row = [];
    TRUST.forEach(function (t, i) {
      if (i > 0) row.push(el('span', { class: 'sdiv', 'aria-hidden': 'true' }));
      row.push(el('span', { class: 'sitem' }, [icon(ICONS[t.icon]), t.label]));
    });
    var pays = PAYMENTS.map(function (p) {
      var style = 'background:' + p.bg + (p.w ? ';min-width:' + p.w + 'px' : '');
      return el('span', { class: 'pay' + (p.border ? ' bordered' : ''), style: style, html: p.html });
    });
    return el('div', { class: 'secure' }, [
      el('div', { class: 'secure-row' }, row),
      el('div', { class: 'pays' }, pays)
    ]);
  }

  /* ---------------- CTA ---------------- */

  function ctaContent(inst, btn) {
    var card = currentCard(inst);
    var line = inst.state.subscribed ? card.subscribe : card.onetime;
    btn.innerHTML = '';
    btn.appendChild(el('span', null, (inst.cfg.ctaPrefix || 'ADD TO CART') + ' ' + BULLET + ' ' + money(line.price)));
    if (line.was) btn.appendChild(el('span', { class: 'ct-was' }, money(line.was)));
  }

  function handleAdd(inst, btn) {
    var card = currentCard(inst);
    var line = inst.state.subscribed ? card.subscribe : card.onetime;
    if (!line || !line.variantId) { console.warn('[ai-sale-buybox] no variantId for', card.id); return; }
    btn.dataset.state = 'loading';
    btn.disabled = true;
    btn.innerHTML = '';
    btn.appendChild(el('span', null, 'Adding…'));
    addToCart(line.variantId, inst.state.subscribed ? line.sellingPlanId : null)
      .then(function () {
        btn.dataset.state = 'ready'; btn.disabled = false;
        ctaContent(inst, btn);
        openCartDrawer();
      })
      .catch(function (err) {
        console.error('[ai-sale-buybox] add failed', err);
        btn.dataset.state = 'error'; btn.disabled = false;
        btn.innerHTML = ''; btn.appendChild(el('span', null, 'Try again'));
      });
  }

  /* ---------------- state ---------------- */

  function currentCard(inst) {
    return inst.cfg.cards.find(function (c) { return c.id === inst.state.selectedId; }) || inst.cfg.cards[0];
  }
  // Tell the host PDP (or Replo page) which pack is selected so the product
  // gallery can swap to the matching hero image. Bubbles to document.
  function emitChange(inst) {
    var card = currentCard(inst);
    try {
      inst.root.dispatchEvent(new CustomEvent('aiSaleBuybox:change', {
        bubbles: true,
        detail: { id: card.id, tubes: card.tubes, heroImage: card.heroImage || null, subscribed: inst.state.subscribed }
      }));
    } catch (e) {}
  }
  function setSelected(inst, id) { if (inst.state.selectedId !== id) { inst.state.selectedId = id; render(inst); emitChange(inst); } }
  function setSubscribed(inst, on) { if (inst.state.subscribed !== on) { inst.state.subscribed = on; render(inst); } }

  /* ---------------- render ---------------- */

  function render(inst) {
    var root = inst.root, cfg = inst.cfg;
    root.innerHTML = '';

    // header
    root.appendChild(el('div', { class: 'sale-head' }, [
      el('span', { class: 'hl', 'aria-hidden': 'true' }),
      el('h2', null, cfg.saleTitle || 'Sale'),
      el('span', { class: 'hl', 'aria-hidden': 'true' })
    ]));

    // cards
    root.appendChild(el('div', { class: 'cards' }, cfg.cards.map(function (c) { return buildCard(inst, c); })));

    // subscribe & save (between cards and stock — Version C)
    root.appendChild(buildSubBox(inst));

    // stock line
    root.appendChild(el('div', { class: 'stock' }, [
      el('span', { class: 'dot', 'aria-hidden': 'true' }),
      cfg.arrival || 'In Stock and Ready to Ship'
    ]));

    // CTA
    var cta = el('button', { class: 'cta', type: 'button', onclick: function () { handleAdd(inst, cta); } });
    ctaContent(inst, cta);
    root.appendChild(cta);

    // secure checkout
    root.appendChild(buildSecure());
  }

  /* ---------------- mount ---------------- */

  function mount(root, cfg) {
    if (!root || !cfg || !cfg.cards || !cfg.cards.length) return null;
    if (cfg.ctaColor) root.style.setProperty('--cta-color', cfg.ctaColor);
    if (cfg.ctaHover) root.style.setProperty('--cta-hover', cfg.ctaHover);
    var inst = {
      root: root, cfg: cfg,
      state: {
        selectedId: cfg.defaultSelectedId || cfg.cards[1] && cfg.cards[1].id || cfg.cards[0].id,
        subscribed: cfg.defaultSubscribed !== false
      }
    };
    render(inst);
    root._aiSale = inst;
    emitChange(inst);
    return inst;
  }

  function init() {
    var cfg = window.AI_SALE_BUYBOX_CONFIG;
    if (!cfg) { console.warn('[ai-sale-buybox] window.AI_SALE_BUYBOX_CONFIG not found; nothing to mount.'); return; }
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    if (!roots.length) { console.warn('[ai-sale-buybox] no ' + ROOT_SELECTOR + ' element found.'); return; }
    roots.forEach(function (r) { if (!r._aiSale) mount(r, cfg); });
  }

  window.aiSaleBuybox = { mount: function (root, cfg) { return mount(root, cfg || window.AI_SALE_BUYBOX_CONFIG); }, init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
